import { make } from "vuex-pathify"
import _ from "lodash"

import AppAPI from "@/api/app"

import * as defaults from "./defaults"

const state = () => {
  return {
    appConfig: null,

    apiResponseState: _.cloneDeep(defaults.API_RESPONSE_STATE_TEMPLATE),

    drawer: null,

    videoTutorial: null,
  }
}

const actions = {
  clearApiResponseState({ commit }) {
    commit(
      "SET_API_RESPONSE_STATE",
      _.cloneDeep(defaults.API_RESPONSE_STATE_TEMPLATE)
    )
  },

  loadAppConfig({ commit, state }, { appCode, cid }) {
    if (!state.appConfig) {
      return AppAPI.loadAppConfig(appCode, cid).then(response => {
        commit("SET_APP_CONFIG", response)

        return response
      })
    }

    return state.appConfig
  },

  resetApiResponseState({ commit }) {
    commit(
      "SET_API_RESPONSE_STATE",
      _.cloneDeep(defaults.API_RESPONSE_STATE_TEMPLATE)
    )
  },

  setApiResponseState({ commit }, response) {
    commit("SET_API_RESPONSE_STATE", response)
  },
}

const getters = {
  ...make.getters(state),
}

const mutations = {
  ...make.mutations(state),
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
